import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class DownloadFileAPI {
    constructor() {
        this.baseUrl = new URL("bussched/", apiBusSchedBaseURL);
    }

    downloadLayout(layoutId) {
        return API.authenticatedRequest({
            url: new URL(`layouts/export/${layoutId}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        }, false);
    }
}



// WEBPACK FOOTER //
// ./src/api/bussched/DownloadFileAPI.js